module.exports = __webpack_public_path__ + "img/9788954427319.18f158a6.jpg";